const refreshApi = process.env.VUE_APP_REFRESH_JWT_TOKEN
const sessionCheckApi = '/api/account/auth-app/status'
const SIGN_IN_REDIRECT_ALERT_MS = 3000

export const session = {signedIn: null, sentToSignInAt: 0}

const sendToSignIn = (router) => {
	session.signedIn = false
	session.sentToSignInAt = Date.now()
	router.push('/')
}

export const isSignInRedirectAlert = () => Date.now() - session.sentToSignInAt < SIGN_IN_REDIRECT_ALERT_MS

async function sendAuthenticatedRequest(url, router, requestOptions, unAuthdQueryParams = null) {
	let response;
	try {
		response = await fetch(url, requestOptions);
		if (response.status === 401) {
			// If response status is 401 (Unauthorized), attempt to refresh the access token
			const refreshResponse = await fetch(refreshApi, {
				credentials: 'include'
			});
			if (refreshResponse.status === 200) {
				// If refresh token succeeds, retry the original request
				response = await fetch(url, requestOptions);

				if (response.status === 401) {
					sendToSignIn(router)
				}
			} else {
				if (unAuthdQueryParams && typeof unAuthdQueryParams === 'object') {
					Object.entries(unAuthdQueryParams).forEach(([key, value]) => {
						sessionStorage.setItem(key, value);
					});
				}
				sendToSignIn(router)
			}
		}
		if (response.ok) session.signedIn = true
	} catch (error) {
		console.error('Error in authenticated request:', error);
	}
	return response;
}

async function checkSession() {
	try {
		let response = await fetch(sessionCheckApi, {credentials: 'include'})
		if (response.status === 401) {
			const refreshResponse = await fetch(refreshApi, {credentials: 'include'})
			if (refreshResponse.status === 200) response = await fetch(sessionCheckApi, {credentials: 'include'})
		}
		if (response.status === 401) session.signedIn = false
		else if (response.ok) session.signedIn = true
	} catch (error) {
		console.error('Error checking session:', error);
	}
	return session.signedIn
}

async function refreshTokens() {
	await fetch(refreshApi, {
		credentials: 'include'
	});
}

export {sendAuthenticatedRequest, checkSession, refreshTokens};
